"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BooleanEditor = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
function BooleanEditor(_a) {
    var label = _a.label, value = _a.value, onChange = _a.onChange;
    return (react_1.default.createElement(material_1.FormControlLabel, { label: label, control: react_1.default.createElement(material_1.Switch, { checked: value, onChange: function (_e, checked) { return onChange(checked); } }) }));
}
exports.BooleanEditor = BooleanEditor;
